



















































/* eslint-disable @typescript-eslint/camelcase */ 
 
    import {   bateriaService } from '@/servicegerente'; 
    import {Watch, Component, Vue } from 'vue-property-decorator'; 
	  
	@Component({
		components: {  },
	 })
    export default class GuiaEdit extends Vue {
 
        private model: any = null; 
		private nivel: any= null;  
		private ativo: any= null;

		private urlRetorno: any= '/v2/administracao/bateria/show/' + this.$route.params.id; 
		private errors: any = { };
  
        created() { 
			 
            window.alertProcessando();
            bateriaService.getModel(this.$route.params.id)
                .then(response => {
                    this.model = response;
                    window.alertProcessandoHide();
                })
                .catch(error => {
                    window.toastErro('Não foi possivel achar o configuração ', error.data);
                    window.alertProcessandoHide();
                     
                }); 
        }
 
        @Watch('model')
		tabelaAtualizada(newVal: any) {  
			this.nome = this.model.nome;   
			this.nivel = this.model.nivel;  
			this.ativo = this.model.ativo; 
        }
         
		salvar() {
			window.alertProcessando();
			const dados = { 
				nivel: this.nivel,  
				nome: this.nome,  
				ativo: this.ativo,  
			};  
			  
			bateriaService.update( this.$route.params.id ,   dados )
			.then(response => {
				window.toastSucesso(response);  
				window.alertProcessandoHide();
				this.$router.push(  this.urlRetorno )
			})
			.catch(error => {  
				window.alertProcessandoHide();
				this.errors = error.data.error; 
				console.log(error);
			});  
		} 
  
    }
 
